import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import { Element, scroller } from "react-scroll";
import firebase from "firebase/compat/app";

const Chapter1_5 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);
  const location = useLocation(); 

  const questions = [
    {
      question:
        "Frage 1: Wodurch unterscheiden sich Cyberkriminelle von Hacktivisten?",
      options: [
        {
          value: "A",
          label: "Hacktivisten sind eher politisch oder sozial motiviert.",
        },
        {
          value: "B",
          label: "Hacktivisten geht es vor allem um den finanziellen Gewinn.",
        },
      ],
      correct: "A",
    },
    {
      question: "Frage 2: Was ist ein böswilliger Insider?",
      options: [
        {
          value: "A",
          label:
            "Eine Person innerhalb einer Organisation, die absichtlich vertrauliche Informationen missbraucht oder schädliche Aktivitäten ausführt.",
        },
        {
          value: "B",
          label:
            "Eine Person, die versehentlich Sicherheitsvorschriften missachtet und unbeabsichtigt Daten gefährdet.",
        },
      ],
      correct: "A",
    },
  ];
  
  useEffect(() => {
    if (location.hash) {
      scroller.scrollTo(location.hash.substring(1), {
        duration: 500,
        smooth: true,
        offset: -50,
      });
    }
  }, [location]);
  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/cybersecurity/login"); 
      }
    });

    
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 1_5.js:", userId);
  }, [userId]);

  const handleLogout = () => {
   
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

     
        const userDoc = await db.collection("cybersecurityProgress").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
         
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .update({
              lastChapter: "1_5",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("1_5"),
            });
          console.log("Dokument aktualisiert mit Kapitel 1_5.");
        } else {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .set({
              lastChapter: "1_5",
              completedChapters: ["1_5"],
            });
          console.log("Dokument erstellt mit Kapitel 1_5.");
        }

        navigate("/cybersecurity/2_1"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/cybersecurity/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/cybersecurity/course-overview"
                >
                  Was ist Cybersecurity?
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Wer sind die Angreifer?
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-3">Kapitel 1: Was ist Cybersecurity?</h3>
          <h2 className="text-center p-3">Wer sind die Angreifer</h2>
          <img
            src="./images/angreifer.webp"
            alt="Transparent"
            style={{ position: "relative", maxWidth: "30%", height: "auto" }}
          />
        </div>
        <div className="p-5 text-center">
          <p className="pt-3 col-lg-11 mx-auto">
            Cyberkriminalität ist heute ein äußerst lukratives Geschäft, das in
            manchen Fällen sogar mehr Gewinn abwirft als der internationale
            Drogenhandel. Allerdings steckt nicht immer ein finanzielles Motiv
            hinter einem Angriff. Diejenigen, die ihn ausführen, können sich in
            ihren Fähigkeiten, Ressourcen und Zielen erheblich voneinander
            unterscheiden. Manche Angreifer handeln aus reiner Neugierde, andere
            aus politischen Überzeugungen, wieder andere aus Habgier oder sogar
            im Auftrag von Staaten. Diese Unterschiede beeinflussen nicht nur
            die Art der Angriffe, sondern auch die Methoden, die zur Abwehr
            erforderlich sind. Daher ist es hilfreich, sich kurz mit den unterschiedlichen Angreifern sowie deren Zielen und Motiven zu befassen.
          </p>
        </div>
        <div className="p-5 text-center">
          <h2 className="p-5">Script Kiddies</h2>
          <h4 className="gelb pb-5 text-center ">Die Neulinge im Cyberraum </h4>
          <img
            src="./images/scriptkiddie.webp"
            class="rounded p-2 float-start"
            alt="Scriptkiddie"
            style={{
              maxWidth: "200px",
              height: "200px",
            }}
          />
          <p className="col-lg-11 mx-auto">
            Script Kiddies besitzen meist nicht das technische Wissen, um eigene
            komplexe Angriffe zu entwickeln. Sie greifen daher auf vorgefertigte
            Tools zurück. Diese Tools, die häufig von erfahrenen Hackern
            entwickelt und online geteilt werden, ermöglichen es selbst
            Anfängern, Angriffe durchzuführen. Der Begriff „Script Kiddie“ ist
            deshalb oft abwertend gemeint und verweist auf die fehlenden
            Fähigkeiten dieser Personen, zur „Kunst“ des Hackens beizutragen.
            <br />
            <br />
            Script Kiddies rebellieren gegen das „System“, verfolgen dabei
            jedoch keine besondere politische oder soziale Agenda. Ihr Ziel ist
            oft, Anerkennung in der Hacker-Community zu erlangen, ihre
            Zugehörigkeit zu beweisen oder einfach ihre Neugier zu stillen. Für
            viele von ihnen ist das Hacken mehr ein Spiel als eine ernsthafte
            kriminelle Handlung.
            <br />
            <br />
            Auch wenn Script Kiddies im Vergleich zu professionellen
            Cyberkriminellen oft als weniger gefährlich gelten, sollten sie
            nicht unterschätzt werden. Ihre Angriffe können beträchtlichen
            Schaden anrichten, besonders wenn sie zufällig auf kritische Systeme
            oder sensible Daten stoßen. Da ihnen oft das Verständnis für die
            Konsequenzen ihrer Handlungen fehlt, können ihre Angriffe
            unvorhersehbare und schwerwiegende Folgen haben.
          </p>

          <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
            <img
              src="/images/attack.svg"
              alt="Angriff"
              style={{
                position: "relative",
                maxWidth: "10%",
                height: "auto",
              }}
            />
            Ein bekanntes Beispiel für einen Script-Kiddie-Angriff ist der
            Angriff auf die Webseite von TalkTalk, einem britischen
            Telekommunikationsunternehmen, im Jahr 2015. Bei diesem Vorfall
            nutzte ein 15-jähriger Angreifer vorgefertigte Tools und Skripte, um
            eine Schwachstelle in der Website-Sicherheit auszunutzen. Dieser
            Angriff führte dazu, dass die persönlichen Daten von rund 157.000
            Kunden kompromittiert wurden, darunter Namen, Adressen und
            Bankdaten.
          </p>
        </div>
        <div className="grey-section">
          <div className="p-5 col-lg-8 mx-auto text-center">
            <h2 className="p-5">Hacktivisten</h2>
            <h4 className="gelb pb-5 text-center ">
              Die digitalen Aktivisten{" "}
            </h4>
            <img
              src="./images/hacktivist.webp"
              class="rounded p-2 float-start"
              alt="Hacktivist"
              style={{
                maxWidth: "200px",
                height: "200px",
              }}
            />

            <p className="col-lg-11 mx-auto">
              Hacktivisten – ein Begriff aus „Hacking“ und „Aktivismus“ – sind
              Einzelpersonen oder Gruppen, die das Internet als Plattform für
              politischen oder sozialen Protest nutzen. Sie sehen sich selbst
              als digitale Rebellen oder Freiheitskämpfer, die gegen
              Ungerechtigkeit, Korruption, Zensur oder andere gesellschaftliche
              Missstände vorgehen. Obwohl sie ähnliche Techniken wie
              Cyberkriminelle verwenden, unterscheidet sie ihre Motivation: Sie
              handeln nicht aus Gewinnstreben, sondern aus einer tiefen
              Überzeugung für ihre Sache. Ihre Angriffe sind oft spektakulär und
              ziehen viel Aufmerksamkeit auf sich, sind jedoch auch hochgradig
              umstritten, da sie häufig illegale Mittel einsetzen, um ihre
              politischen oder sozialen Ziele zu erreichen.
              <br />
              <br />
              Bekannte Hacktivisten-Gruppen wie Anonymous oder LulzSec bestehen
              meist aus losen Kollektiven von Hackern, die anonym unter
              Pseudonymen agieren. Sie besitzen kein festes Führungssystem und
              operieren oft spontan und dezentral, was ihre Aktionen schwer
              vorhersehbar und ihre Mitglieder schwer identifizierbar macht.
              <br />
              <br />
              Um ihre Botschaften zu verbreiten und ihre Ziele zu erreichen,
              setzen Hacktivisten verschiedene Methoden ein, die oft darauf
              abzielen, öffentlichen Druck zu erzeugen oder die betroffenen
              Organisationen zu diskreditieren. Ein häufig verwendetes Mittel
              ist das sogenannte Defacement: Dabei hacken sie Websites und
              ändern deren Inhalte, um ihre Botschaften zu platzieren. Diese
              Änderungen reichen von der Anpassung des Homepage-Designs bis hin
              zur Veröffentlichung von Manifesten oder Erklärungen.
            </p>
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
              Ein bekanntes Beispiel für Hacktivismus ist die Operation Payback
              von der Gruppe Anonymous im Jahr 2010. Diese Aktion war eine
              Reaktion auf die Blockade der Finanztransaktionen zur
              Enthüllungsplattform WikiLeaks durch große Unternehmen wie Visa,
              MasterCard und PayPal, nachdem WikiLeaks vertrauliche
              Regierungsinformationen veröffentlicht hatte. Anonymous legte die
              Websites dieser Unternehmen lahm um damit gegen die vermeintliche
              Zensur zu protestieren.
            </p>
          </div>
        </div>

        <div className="gelb-section">
          <div className="p-5 col-lg-8 mx-auto text-center">
            <h2 className="p-5">Cyberkriminelle</h2>
            <h4 className="gelb pb-5 text-center ">
              Profitgetriebene Angreifer{" "}
            </h4>
            <img
              src="./images/cyberkrimineller.webp"
              class="rounded p-2 float-start"
              alt="Hacktivist"
              style={{
                maxWidth: "200px",
                height: "200px",
              }}
            />

            <p className="col-lg-11 mx-auto">
              Cyberkriminelle sind wahrscheinlich die bekannteste und
              gefürchtetste Gruppe von Angreifern in der digitalen Welt. Sie
              sind hochmotiviert, geschickt und oft gut organisiert. Ihr
              Hauptantrieb ist meist finanzieller Gewinn ist. Ihre Aktionen reichen
              von kleinen Betrügereien bis hin zu groß angelegten, international
              koordinierten Angriffen.
              <br />
              <br />
              Mit ihren fortgeschrittenen technischen Fähigkeiten nutzen
              Cyberkriminelle gezielt die Anonymität des Internet, um weltweit
              zu agieren und Strafverfolgungsbehörden zu entkommen. Zu den
              häufigsten Methoden gehören:
              <br />
              <br />
              <strong>Finanzielle Erpressung:</strong> Durch Verschlüsselung von
              Daten oder die Drohung, sensible Informationen zu veröffentlichen,
              erpressen Cyberkriminelle Lösegeld.
              <br />
              <br />
              <strong>Diebstahl von Finanzdaten: </strong>Kreditkartennummern,
              Bankkontoinformationen und andere finanzielle Daten sind für sie
              sehr wertvoll und werden entweder selbst genutzt oder im Darknet
              verkauft.
              <br />
              <br />
              <strong>Identitätsdiebstahl:</strong> Sie stehlen persönliche
              Informationen, um Identitäten zu fälschen und betrügerische
              Transaktionen durchzuführen oder die gestohlenen Identitäten an
              andere Kriminelle weiterzuverkaufen.
            </p>
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
             Ein klar finanziell motiviertes Beispiel aus 2025 ist der massive Krypto-Hack auf verschiedene Kryptoplattformen, bei dem Cyberkriminelle Kryptowährungen im Gesamtwert von mehreren Milliarden US-Dollar erbeuteten – darunter insbesondere ein einzelner großer Schlag gegen die Börse Bybit, bei dem rund 1,4 – 1,5 Milliarden USD gestohlen wurden. Bei diesen Angriffen suchten die Täter direkt finanziellen Gewinn, indem sie Sicherheitslücken ausnutzten, Krypto-Wallets kompromittierten und gestohlene Coins schnell weitertransferierten. Solche Vorfälle trugen dazu bei, dass 2025 insgesamt mehr als 3 Milliarden USD an Kryptowerten durch Hacks und Diebstähle verloren gingen, was das Jahr zu einem der teuersten für Krypto-Cybercrime macht. (finanzen-net - "Krypto-Hacks 2025: Rekordverluste durch Cyberkriminalität")
            </p>
            <p className="col-lg-11 mx-auto">
              Cyberkriminelle stellen eine erhebliche Bedrohung für Unternehmen,
              Regierungen und Privatpersonen dar. Ihre Angriffe können nicht nur
              zu erheblichen finanziellen Verlusten führen, sondern auch
              sensible Informationen gefährden, die Integrität von Systemen
              untergraben und das Vertrauen in digitale Dienstleistungen
              erschüttern.
            </p>
          </div>
        </div>
        <div className="p-5 text-center">
          <h2 className="p-5">Cybermafia</h2>
          <h4 className="gelb pb-5 text-center ">Organisierte Banden </h4>
          <img
            src="./images/cybermafia.webp"
            class="rounded p-2 float-start"
            alt="Cybermafia"
            style={{
              maxWidth: "200px",
              height: "200px",
            }}
          />

          <p className="col-lg-11 mx-auto">
            Während viele Cyberkriminelle allein oder in kleinen Gruppen
            agieren, gibt es auch gut organisierte Netzwerke, die als Cybermafia
            bekannt sind. Diese Organisationen unterscheiden sich von
            herkömmlichen Cyberkriminellen durch ihre Größe, Struktur und
            Professionalität. Die Cybermafia betreibt Cyberkriminalität auf
            einem völlig anderen Niveau und erinnert mit ihrer Hierarchie und
            Organisation an traditionelle Verbrecherorganisationen wie z. B. der Mafia.
            Mit umfangreichen Ressourcen und modernster
            Technologie führen sie ihre kriminellen Aktivitäten gezielt und oft
            unentdeckt aus.
            <br />
            <br />
            Die Cybermafia verfügt über eine klare Hierarchie und spezialisierte
            Rollen: Anführer entwickeln Strategien, technische Experten führen
            Angriffe durch, und andere Mitglieder kümmern sich um Logistik und
            Finanzen. Sie operieren häufig über das Dark Web, wo sie illegale
            Waren und Dienstleistungen anbieten und ihre kriminellen Geschäfte
            abwickeln. Die Cybermafia kontrolliert oft große Märkte im Dark Web,
            auf denen gestohlene Daten, Waffen, Drogen und andere illegale Güter
            gehandelt werden, und erzielt damit enorme Gewinne.
            <br />
            <br />
            Ein zentraler Bestandteil des Geschäftsmodells dieser Täter ist die systematische Geldwäsche der Beute. Mithilfe
            gefälschter Unternehmen, Cryptowährungen und Bankkonten werden
            illegale Einnahmen gewaschen und ins legale Finanzsystem integriert.
            Aufgrund ihrer Ressourcen und ihres Fachwissens sind diese
            Organisationen in der Lage, Angriffe im großen Maßstab
            durchzuführen, die erhebliche wirtschaftliche und soziale
            Auswirkungen haben können.
          </p>
          <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
            <img
              src="/images/attack.svg"
              alt="Angriff"
              style={{
                position: "relative",
                maxWidth: "10%",
                height: "auto",
              }}
            />
            Ein bekanntes Beispiel für die Cybermafia ist die „Carbanak-Gruppe“.
            Diese internationale Organisation war verantwortlich für eine der
            größten und komplexesten Cyberangriffe. Zwischen 2013 und 2018
            gelang es der Carbanak-Gruppe, Banken in mehr als 40 Ländern
            anzugreifen und über eine Milliarde Dollar zu stehlen. Die Gruppe
            infizierte Banknetzwerke mit schädlicher Software, die es ihnen
            ermöglichte, Geldautomaten fernzusteuern und Überweisungen auf ihre
            eigenen Konten umzuleiten.
          </p>
        </div>

        <div className="grey-section">
          <div className="p-5 col-lg-8 mx-auto text-center">
            <h2 className="p-5">Cyberterroristen</h2>
            <h4 className="gelb pb-5 text-center ">
              Die digitalen Attentäter{" "}
            </h4>
            <img
              src="./images/cyberterror.webp"
              class="rounded p-2 float-start"
              alt="Cyberterroristen"
              style={{
                maxWidth: "200px",
                height: "200px",
              }}
            />

            <p className="col-lg-11 mx-auto">
              Cyberterroristen nutzen digitale Mittel, um Terror zu verbreiten,
              politische oder religiöse Ziele zu verfolgen und sogar Nationen zu
              destabilisieren. Anders als gewöhnliche Cyberkriminelle sind sie
              besonders gefährlich, weil sie weniger am finanziellen Gewinn
              interessiert sind, sondern gezielt Angst und Chaos stiften wollen.
              <br />
              <br />
              Solche Akteure können Einzelpersonen, lose Gruppen oder staatlich
              unterstützte Organisationen sein. Sie setzen Cyberangriffe als
              moderne Kriegsführung ein, um ihre ideologischen Ziele zu
              erreichen. Ihre Methoden sind ausgeklügelt, um maximalen Schaden zu verursachen, sei es
              durch Angriffe auf kritische Infrastrukturen wie Energie- oder
              Verkehrssysteme, Verbreitung von Desinformation oder Hacking von
              Regierungs- und Militärsystemen.
              <br />
              <br /> Um dieser wachsenden Gefahr zu begegnen, ist es besonders für
              Regierungen aber auch für Unternehmen von entscheidender Bedeutung, robuste
              Cybersecurity-Maßnahmen zu implementieren, Strategien zur
              Bekämpfung von Desinformation zu entwickeln und die internationale
              Zusammenarbeit beim Kampf gegen Cyberterror zu stärken. <br />
            </p>

            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
            Im Dezember 2025 wurden sowohl IT-Systeme als auch Industrie-Steuerungssysteme der polnischen Energieinfrastruktur kompromittiert, was Sicherheitsbehörden und CERTs als destruktiven Angriff einstufen, der gezielt kritische Infrastruktur lahmlegen sollte. Die Analyse mehrerer Sicherheitsteams macht staatlich-nahe Gruppen wie Sandworm oder „Berserk Bear“ mit einer Beteiligung mit politisch/strategischer Motivation verantwortlich. Ein solcher Vorfall zeigt, wie Cyberangriffe nicht nur Daten/Profit ins Visier nehmen, sondern auch darauf ausgelegt sein können, öffentliche Ordnung, Energieversorgung und gesellschaftliche Stabilität zu stören. Er demonstrierte eindrucksvoll
              das reale Bedrohungspotenzial von Cyberterrorismus für die
              Gesellschaft und zeigte, wie Cyberangriffe als Teil größerer
              geopolitischer Konflikte eingesetzt werden können.
            </p>
          </div>
        </div>
        <div className="gelb-section">
          <div className="p-5 col-lg-8 mx-auto text-center">
            <h2 className="p-5">Cyber Warrior</h2>
            <h4 className="gelb pb-5 text-center ">Die digitalen Soldaten </h4>

            <img
              src="./images/cyberwarrior.webp"
              class="rounded p-2 float-start"
              alt="Cyberwarrior"
              style={{
                maxWidth: "200px",
                height: "200px",
              }}
            />

            <p className="col-lg-11 mx-auto">
              Während Cyberterrorismus von nicht-staatlichen, extremistischen
              Gruppen oder Einzelpersonen mit ideologischen Motiven verübt wid,
              wird der Cyberwar wird in der Regel von staatlichen Akteuren oder
              staatlich unterstützten Gruppen durchgeführt. Cyber-Warrior sind
              hochqualifizierte IT-Spezialisten, die im Auftrag von Staaten
              operieren und Cyberangriffe als Mittel moderner Kriegsführung
              einsetzen. Sie sind Teil einer größeren geopolitischen Strategie
              und verfolgen präzise, oft militärische Ziele. <br />
              <br /> Sie gehören regulären Streitkräften an, dienen in
              speziellen Cyber-Einheiten oder operieren in geheimen Netzwerken.
              Ihre Aktivitäten sind tief in der nationalen Sicherheit und
              Verteidigung verwurzelt und umfassen Spionage, Sabotage kritischer
              Infrastrukturen, psychologische Kriegsführung und die Vorbereitung
              physischer Konflikte. <br />
              <br />
              Methoden von Cyber-Warriors, die im Auftrag einer Regierung
              handeln, sind in der Regel nicht strafbar im eigenen Land, da sie
              oft von der Regierung autorisiert und als Teil der nationalen
              Sicherheit oder Verteidigung betrachtet werden. Allerdings sind
              solche Methoden im internationalen Recht umstritten. Sie werden in
              anderen Ländern als illegal betrachtet, da sie gegen 
              Gesetze oder internationale Vereinbarungen verstoßen. Ein
              Land, das Opfer solcher Angriffe wird, wird die Handlungen als
              Straftat einstufen und den Verantwortlichen strafrechtlich
              verfolgen, sofern es gelingt, die Beteiligung nachzuweisen und
              die Täter vor Gericht zu bringen.
            </p>
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
              Eine Hackergruppe drang 2014 in die Computersysteme des Filmstudios
              Sony Pictures ein und erbeutete eine enorme Menge sensibler Daten,
              darunter vertrauliche Emails, Finanzinformationen und
              unveröffentlichtes Filmmaterial. Der Angriff stand im Zusammenhang
              mit dem geplanten Release der Komödie "The Interview", die eine
              fiktive Ermordung des nordkoreanischen Machthabers Kim Jong Un zum
              Thema hatte. Die Hacker drohten mit weiteren Angriffen, sollte der
              Film in die Kinos kommen, was Sony dazu veranlasste, den Kinostart
              zunächst abzusagen. US-Behörden kamen zu dem Schluss, dass
              Nordkorea hinter dem Angriff steckte. 2018 erhob das
              US-Justizministerium Anklage gegen einen nordkoreanischen
              Programmierer, was die Vermutung einer staatlichen Beteiligung
              Nordkoreas weiter untermauerte. Der als Sony Pictures Hack bekannt
              gewordene Angriff verdeutlicht die zunehmende Verschmelzung von
              Cyberkriminalität, politischen Motiven und internationalen
              Spannungen im digitalen Zeitalter.
            </p>
          </div>
        </div>

        <div className="grey-section">
          <div className="p-5 col-lg-8 mx-auto text-center">
            <h2 className="p-5">Insider</h2>
            <h4 className="gelb pb-5 text-center ">Bedrohung von innen </h4>
            <img
              src="./images/insider.webp"
              class="rounded p-2 float-start"
              alt="Insider"
              style={{
                maxWidth: "200px",
                height: "200px",
              }}
            />
            <Element name="insider">
              <p className="col-lg-11 mx-auto">
                Eine oft übersehene Gefahr in der Cybersecurity sind Insider: Personen innerhalb einer Organisation, die ihren legitimen
                Zugang missbrauchen, um Schaden anzurichten. Diese Bedrohung ist
                besonders gefährlich, da Insider über Vertrauen, Zugang und
                Wissen verfügen, die es ihnen ermöglichen, Sicherheitsmaßnahmen zu umgehen.
                <br />
                <br />
                Insider können aktuelle oder ehemalige Mitarbeiter,
                Auftragnehmer oder andere Personen sein, die durch ihren Zugang
                zur Organisation böswillige Aktivitäten ausführen. Man
                unterscheidet zwei Haupttypen:
                <br />
                <br />
                <strong>Böswillige Insider:</strong> Diese Personen handeln
                absichtlich und aus Motiven wie Rache, finanzieller Gier oder
                ideologischen Überzeugungen. Sie stehlen sensible Daten, geben
                Zugangsdaten weiter oder sabotieren Systeme. Besonders in
                Branchen mit wertvollen Informationen kann dies verheerende
                Folgen haben. Ein Mitarbeiter, der das Gefühl hat, ungerecht
                behandelt worden zu sein – sei es durch eine Kündigung, eine
                Nichtbeförderung oder andere wahrgenommene Ungerechtigkeiten –
                könnte versuchen, sich an seinem Arbeitgeber zu rächen und
                sensible Informationen wie Kundenlisten, Geschäftsgeheimnisse
                oder geistiges Eigentum zu stehlen, um sie an Konkurrenten zu
                verkaufen oder den Arbeitgeber zu Erpressen. Dies kann besonders
                in Branchen, in denen Informationen von hohem wirtschaftlichen
                Wert sind, wie im Finanz- oder Technologiebereich, verheerende
                Auswirkungen haben.
              </p>
            </Element>
            <p className="col-lg-11 mx-auto">
              In einigen Fällen handeln Insider aus ideologischen, politischen oder religiösen Gründen. 
              Diese Überzeugungen können sie dazu treiben, Informationen offenzulegen oder Systeme zu
              sabotiere. Dazu
              gehört neben dem Diebstahl von Daten auch die bewusste Weitergabe
              von Zugangsdaten oder bewusste Sabotage z. B. durch Datenlöschung.{" "}
            </p>
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
              Ein bekanntes Beispiel für einen eher ideologischen, aber trotzdem
              böswilligen Insider-Angriff ist der Fall von Edward Snowden, einem
              ehemaligen Mitarbeiter der National Security Agency (NSA) der USA.
              Snowden nutzte seinen Zugang zu hochsensiblen Informationen, um
              geheime Dokumente zu kopieren und offenzulegen, die das Ausmaß der
              Überwachungsprogramme der NSA enthüllten. Dieser Fall führte zu
              einer weltweiten Debatte über Datenschutz und staatliche
              Überwachung, während er gleichzeitig die potenziellen Risiken
              aufzeigte, die Insider-Angriffe mit sich bringen können.
              <br />
              <br />
            </p>
            <p className="col-lg-11 mx-auto">
              {" "}
              <strong>Nachlässige Insider</strong>: Diese Insider handeln nicht
              bewusst böswillig, verursachen aber durch Nachlässigkeit oder
              Unachtsamkeit Sicherheitsprobleme, z. B. durch unsichere
              Passwörter, das Klicken auf bösartige Links oder unsachgemäße
              Handhabung sensibler Daten.
            </p>
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
              Im Jahr 2018 verursachte ein nachlässiger Insider in einem großen
              Krankenhaus in Großbritannien ein massives Datenleck, als er
              versehentlich eine E-Mail mit sensiblen Patientendaten an den
              falschen Empfänger schickte. Obwohl der Vorfall nicht böswillig
              war, führte er zu einer erheblichen Gefährdung der Privatsphäre
              der Patienten und hatte weitreichende rechtliche und finanzielle
              Folgen für das Krankenhaus.
            </p>
            <p className="col-lg-11 mx-auto">
              Insider-Bedrohungen stellen eine der schwierigsten
              Herausforderungen in der Cybersecurity dar. sie sind oft schwer zu
              erkennen und zu verhindern. Im Gegensatz zu externen
              Angreifern haben Insider legitimen Zugang zu den Systemen und
              Daten einer Organisation. Das macht es fast unmöglich, ihre Aktivitäten
              zu überwachen, ohne die Privatsphäre und das Vertrauen der
              Mitarbeiter zu beeinträchtigen.
              <br />
              <br />
              Für Unternehmen ist es daher entscheidend, sowohl technische als
              auch organisatorische Maßnahmen zu ergreifen, um sich vor
              Insider-Bedrohungen zu schützen. Dies kann den Einsatz von
              Überwachungstools zur Erkennung ungewöhnlicher Aktivitäten,
              regelmäßige Schulungen und Sensibilisierung der Mitarbeiter für
              Sicherheitspraktiken, sowie die Implementierung strengerer
              Zugriffsrechte und Überprüfungsprozesse umfassen.
            </p>
          </div>
        </div>
      </div>

      {/* Fragenteil */}
      <div className="container pt-5 my-5">
        <div className="text-center m-4">
          <h2>Überprüfe dein Wissen</h2>
          <p className="col-lg-11 mx-auto">
            Mit den richtigen Antworten kommst du weiter!
          </p>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-8 text-start">
            <form onSubmit={handleSubmit}>
              {questions.map((question, index) => (
                <div key={index} className="mb-4">
                  <p className="fs-4">{question.question}</p>{" "}
                  {question.options.map((option) => (
                    <div key={option.value} className="form-check">
                      <input
                        className="form-check-input me-2"
                        type="radio"
                        name={`question${index}`}
                        value={option.value}
                        checked={selectedAnswers[index] === option.value}
                        onChange={() => handleAnswerChange(index, option.value)}
                      />
                      <label className="form-check-label fs-5">
                        {option.label}
                      </label>{" "}
                    </div>
                  ))}
                </div>
              ))}
              {error && <p className="text-danger">{error}</p>}
              <div className="text-center">
                <button type="submit" className="btn btn-primary">
                  überprüfen
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Ende Fragenteil */}
    </div>
  );
};

export default Chapter1_5;
